<ng-select [items]="itemsData"
           placeholder="Select Items"
           [multiple]="true"
           [clearable]="false"
           bindLabel="{{bindLabel}}"
           bindValue="{{bindValue}}"
           [closeOnSelect]="false"
           [(ngModel)]="selectedValues"
           (change)="changeSelection($event)"
           (close)="close($event)"
           (open)="onOpen()"
           (search)="search($event)"
           [searchFn]="ddlOptionsSearch">
  <ng-template ng-header-tmp let-items="items">
    <input type="checkbox" id="chkSelectAll" (change)="toggleCheckAll($event)" [(ngModel)]="selectAllChk" [disabled]="itemsData?.length === 0" class="handCursor" />&nbsp;
    <label for="chkSelectAll" class="handCursor">
      <span style="position: relative; top: -2px; padding: 0px 10px;" [ngStyle]="itemsData?.length === 0 ? {color: '#757575', cursor: 'not-allowed'} : {}">Select All</span>
    </label>
  </ng-template>

  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngIf="selectAllChk===false">
      <span *ngFor="let item of items | slice:0:1">
        <span class="ng-value-label" [ngStyle]=" items.length > 1 ? {'max-width': '130px'} : {'max-width': '180px'}"
              [ngClass]="selectAllChk===true ? '':'addBorder'" matTooltip="{{getLabelText(item)}}" matTooltipPosition="above">{{getLabelText(item)}}</span>
      </span>
    </div>
    <div class="ng-value" *ngIf="selectAllChk===false && items.length > 1">
      <span class="ng-value-label addBorder">{{items.length - 1}} more</span>
    </div>
    <div class="ng-value" *ngIf="selectAllChk===true">
      <span class="ng-value-label increaseFont">All</span>
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
    <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" /> <span style="position: relative; top: -2px; padding: 0px 10px;">{{getLabelText(item)}}</span>
  </ng-template>
</ng-select>
